import { render, staticRenderFns } from "./itemContent.vue?vue&type=template&id=cc194d2e&"
import script from "./itemContent.vue?vue&type=script&lang=js&"
export * from "./itemContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports